import React from 'react';
import { Marker, Circle, Popup } from 'react-leaflet';
import numeral from 'numeral';
import './util.css';

const casesTypeColors = {
    cases: {
        hex: '#CC1034',
        multiplier: 150,
    },
    recovered: {
        hex: '#2f994c',
        multiplier: 150,
    },
    deaths: {
        hex: '#ff7708',
        multiplier: 600,
    },
};

//this sortData is to sort Live Cases by Country
export const sortData = (data) => {
    const sortedData = [...data];

    // return sortedData.sort((a,b) => (a.cases > b.cases ? -1 : 1)); --> this works too

    sortedData.sort((a, b) => {
        if (a.cases > b.cases) {
            return -1;
        } else {
            return 1;
        }
    })
    return sortedData;
};

export const prettyPrintStat = (stat) =>
    stat ? `+${numeral(stat).format("0.0a")}` : "+0";

//this function is to draw circles on the map interactive tooltip
export const showDataOnMap = (data, casesType = 'cases') => (
    data.map(country => (
        <Circle
            center={[country.countryInfo.lat, country.countryInfo.long]}
            fillOpacity={0.4}
            color={casesTypeColors[casesType].hex}
            fillColor={casesTypeColors[casesType].hex}
            radius={
                Math.sqrt(country[casesType]) * casesTypeColors[casesType].multiplier
            }>

            <Popup>
                <div className='info-container'>
                    <div className='info-flag' style={{ backgroundImage: `url(${country.countryInfo.flag})` }} />
                    <div className='info-name'>{country.country}</div>
                    <div className='info-confirmed'>Cases: {numeral(country.cases).format('0,0')}</div>
                    <div className='info-recovered'>Recovered: {numeral(country.recovered).format('0,0')}</div>
                    <div className='info-deaths'>Deaths: {numeral(country.deaths).format('0,0')}</div>
                </div>
            </Popup>
        </Circle>
    ))
);